export const TYPES = {
  CURRENT_LANGUAGE: "language/CURRENT_LANGUAGE",
};
